import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
    selector: 'custome-checkbox',
    templateUrl: './customeCheckbox.component.html',
    styleUrls: ['./customeCheckbox.component.scss']
})

export class customeCheckboxComponent {
    @Input() Style: string = 'slider'; // check, slider

    @Input() name: string;
    @Input() inputValue: boolean;
    @Output() inputValueChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor() { }

    changeStatus() {
        this.inputValue = !this.inputValue;
        this.inputValueChange.emit(this.inputValue)
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/customeCheckbox/customeCheckbox.component.ts